import { createFileRoute } from '@tanstack/react-router';
import { ConfigurationRiskAppetite } from './RiskAppetite';

export const Route = createFileRoute('/console/$orgId/configuration/risk/appetite')({
    staticData: { metadata: { title: 'Risk appetite' } },
    component: () => <ConfigurationRiskAppetite />,
});
